<template>
  <div>
    <mdb-card class="text-left">
       <mdb-card-header color="warning-color text-white">
         <h5><mdb-icon icon="bomb"/>Error</h5>
       </mdb-card-header>
      <mdb-card-body>
        {{error.response.data}}  ({{error.response.status}})
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
  import {mdbCard,mdbCardHeader,mdbCardBody,mdbIcon} from 'mdbvue';

  export default {
    name: 'Error',
    components: {
      mdbCard,mdbCardHeader,mdbCardBody,mdbIcon
    },
    props: {
      error: {
        type: Error,
        default: null
      }
    }
  };
</script>

<style scoped>
</style>
